export enum FirstStepEnum {
  AcceptAllBelow = 'Akceptuję wszystkie poniższe zgody',
  Calculate = 'Oblicz składkę',
  ConsentCepik = 'Wyrażam zgodę na przechowanie i wykorzystanie moich danych, pozyskanych od zakładów ubezpieczeń^^, w procesie analizy potrzeb, w celu przeprowadzenia takich analiz w przyszłości przez Internetowego Agenta Ubezpieczeniowego.',
  FreeCall = 'Bezpłatna pomoc agenta',
  IndicatorStep1 = '1. Start',
  IndicatorStep2 = '2. Twoje dane',
  IndicatorStep3 = '3. Oferty',
  TitlePart1 = 'Kalkulator OC AC',
  TitlePart2 = 'Poznaj cenę online',
}
